
import {
  nextTick,
  defineComponent,
  ref,
  computed,
  watch,
  onBeforeMount,
  onMounted
} from "vue";

export default defineComponent({
  name: "ResizeTextarea",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    rows: {
      type: Number,
      default: 1
    },
    cols: {
      type: Number,
      default: 0
    },
    minHeight: {
      type: Number,
      default: 50
    },
    maxHeight: {
      type: Number,
      default: null
    },
    modelValue: {
      type: String,
      default: ""
    },
    autoResize: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue"],
  setup: (props, { emit }) => {
    const textareaContent = ref<string>("");
    const textarea = ref<HTMLTextAreaElement | null>(null);
    const height = ref<string>("");
    const isScrollEnabled = ref<boolean>(false);

    const unit: string = "px";

    const styles = computed<{
      resize: string;
      height: string;
      overflow: string;
    }>(() => ({
      resize: props.autoResize ? "none !important" : "",
      height: height.value,
      overflow: `${isScrollEnabled.value ? "scroll" : "hidden"} !important`
    }));

    watch(
      () => textareaContent.value,
      () => {
        emit("update:modelValue", textareaContent.value);
        resize();
      }
    );

    watch(
      () => props.modelValue,
      val => {
        textareaContent.value = String(val);
      }
    );

    onBeforeMount(() => {
      nextTick(() => {
        textareaContent.value = props.modelValue;
      });
    });

    const resize = () => {
      const element = textarea.value;
      height.value = "auto !important";
      nextTick(() => {
        if (props.minHeight && element) {
          height.value = `${
            element.scrollHeight < props.minHeight
              ? props.minHeight
              : element.scrollHeight
          }${unit}`;
        }
        if (props.maxHeight && element) {
          if (element.scrollHeight > props.maxHeight) {
            height.value = `${props.maxHeight}${unit}`;
            isScrollEnabled.value = true;
          } else {
            isScrollEnabled.value = false;
          }
        }
      });
    };

    onMounted(() => {
      resize();
    });

    return {
      textareaContent,
      textarea,
      styles,
      resize
    };
  }
});
